import 'core-js/actual/object';

// @ts-ignore
import ClipboardJS from 'clipboard';

import {
	DeepLinkType, downloadUrls, eventCategory, getActivityConfig,
	getAllQueryParams, getCurrentUrl,
	getPandoraData,
	getQueryParam, isFacebook, isInstagram,
	isIOS, isWeChat,
	jumpDeepLink, miloEmit, prefixNumber, registerDeeplinkButton,
} from "./utils";
import {getCurrentLanguage} from "./i18n";
import {MiloResponseType} from "../@types/act";

const CONST_DATA = {
	PANDORA_SHARE_KEY: 'inviteInfo',// 潘多拉分享数据的参数
}

const defaultAvatarImage: string = "images/logo.png";
const defaultAvatarName: string = "Hok player";
const backgroundTemplateImageUrl: string = `https://res.sgameglobal.com/Global/Common/Picture/SkinSharePicN_V2/30{skinId}.jpg`;
const backgroundHeroTemplateImageUrl:string = 'https://res.sgameglobal.com/Global/Common/Picture/HeroSharePicN_V2/{heroId}.jpg';
const MVP_DATA = {
	score: 0,  // 评分
	kill: 0,  // 击杀
	death: 0,  // 死亡
	assist: 0  // 助攻
};

const rewardListData: RewardListType[] = [] as RewardListType[];
const itemListData: ItemListType[] = [] as ItemListType[];


const rewardNameLangKey = {
	"3008244": "reward1",
	"3008914": "reward2",
	"3008915": "reward3",
};

/**
 * 获取潘多拉数据
 */
const pandoraData = getPandoraData<pandoraDataType>(CONST_DATA.PANDORA_SHARE_KEY, {
	module: 'MVPShareGlobal',
	appId: '2269',
	userName: defaultAvatarName,
	code: '',
	playerHeadUrl: defaultAvatarImage
});

console.log("pandoraData===>", pandoraData)

/**
 * 更新页面信息
 */
function updatePageInfo() {
	// 更新页面头像
	const avatarImgDom = document.querySelector('.avatar img') as HTMLImageElement;
	
	let avatarImageUrl = pandoraData.playerHeadUrl;
	if (!avatarImageUrl.startsWith("http") && avatarImageUrl !== defaultAvatarImage) {
		pandoraData.playerHeadUrl = `https://${pandoraData.playerHeadUrl}`
	}
	avatarImgDom.setAttribute("src", pandoraData.playerHeadUrl)
	
	// 更新页面角色名称
	const avatarNameDom = document.querySelector(".id") as HTMLElement;
	avatarNameDom.textContent = pandoraData.userName;
	
	// 更新数据展示
	// updateMvpData();
	// 更新礼包数据
	
	// 更新领奖的记录
}

/**
 * 更新MVP数据展示
 */
// function updateMvpData(){
// 	const mvpDataDom = {
// 		scoreDom:document.querySelector('.pf span'),
// 		killDom:document.querySelector('.js span'),
// 		deathDom:document.querySelector('.sw span'),
// 		assistDom:document.querySelector('.zg span'),
// 	}
// 	for (const mvpInfoKey in MVP_DATA) {
// 		const domKey = `${mvpInfoKey}Dom`;
// 		mvpDataDom[domKey].textContent = MVP_DATA[mvpInfoKey];
// 	}
// }


/**
 * 页面结束
 */
function updatePageEnd() {
	const mainElement = document.querySelector('.main') as HTMLElement;
	const notMainElement = document.querySelector('.not-main') as HTMLElement;
	const headerElement = document.querySelector('.header') as HTMLElement;
	
	mainElement.style.display = 'none';
	notMainElement.style.display = 'block';
	headerElement.style.display = 'none';
}

/**
 * 页面初始话操作
 */
function initPage() {
	updatePageInfo();
	// let jumpPandoraData = {...pandoraData};
	// jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
	// gtag('event', 'jumpDeepLink', {
	// 	...pandoraData,
	// 	'event_category': 'a20240318khrlr',
	// 	'event_label': 'jumpDeepLink'
	// });
	// jumpDeepLink(
	// 	{
	// 		type: DeepLinkType.GOTO_PANDORA,
	// 		pandoraData: jumpPandoraData
	// 	},
	// 	() => {
	// 		console.log("成功跳转")
	// 		gtag('event','jumpDeepLinkSuccess',{
	// 			...pandoraData,
	// 			'event_category': 'a20240318khrlr',
	// 			'event_label': 'jumpDeepLinkSuccess'
	// 		});
	// 	},
	// 	() => {
	// 		console.log('失败跳转');
	// 		gtag('event','jumpDeepLinkFail',{
	// 			...pandoraData,
	// 			'event_category': 'a20240318khrlr',
	// 			'event_label': 'jumpDeepLinkFail'
	// 		});
	// 		let url = downloadUrls.android;
	// 		if (isIOS()) {
	// 			url = downloadUrls.ios;
	// 		}
	// 		console.warn('似乎未能打开游戏，跳转到下载页面：', url);
	// 		location.href = url;
	// 	},
	// 	() => {
	// 		console.log('无法执行跳转');
	// 	}
	// );
}

function onError(err: ErrorEvent) {
	console.error('Uncaught error:', err.error || err.message || err, err);
}

// 全局未捕获错误处理
window.addEventListener('error', onError);

function clickCopyBtnEvent() {
	console.log("点击复制按钮上报")
	gtag('event', 'clickCopyBtn', {
		'event_category': eventCategory,
		'event_label': 'clickCopyBtn'
	})
	let jumpPandoraData = {...pandoraData};
	jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
	jumpDeepLink({
		type: DeepLinkType.GOTO_PANDORA,
		pandoraData: jumpPandoraData
	}, () => {
		console.log("复制链接成功拉取客户端上报")
		gtag('event', 'copyBtnJumpDeepLinkSuccess', {
			'event_category': eventCategory,
			'event_label': 'copyBtnJumpDeepLinkSuccess'
		})
	}, () => {
		let url = downloadUrls.android;
		console.warn('似乎未能打开游戏，跳转到下载页面：', url);
		if (isIOS()) {
			url = downloadUrls.ios;
			console.log("复制链接跳转商城IOS上报")
			gtag('event', 'copyBtnAndOpenAPPStore', {
				'event_category': eventCategory,
				'event_label': 'copyBtnAndOpenAPPStore'
			})
		} else {
			console.log("复制链接下载APK文件上报")
			gtag('event', 'copyBtnAndDownloadAPK', {
				'event_category': eventCategory,
				'event_label': 'copyBtnAndDownloadAPK'
			})
		}
		location.href = url;
	})
}


(async function () {
	// 从链接中获取语言，如果无法获取则尝试从系统语言中获取
	let lang = getCurrentLanguage(language_data, 'lang', 'langStr') || 'en';
	app.switchLanguage(lang);
	let jumpPandoraData = {...pandoraData};
	jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
	registerDeeplinkButton('.jump_game', jumpPandoraData, () => {
		console.log("成功跳转~")
	}, () => {
		console.log("失败跳转~")
		if ( isFacebook() || isInstagram() || isWeChat()) {
			app.show_window = true;
			return false;
		}
	})
	
	// 复制链接
	new ClipboardJS('.btn-copy', {
		text() {
			// let copyText = app.arr.Txt_H5_CopyWords;
			// let shareCode = pandoraData.code;
			// let jumpCode = pandoraData.jumpCode || '';
			// let content = copyText.replace("{0}", shareCode).replace("{1}", jumpCode);
			const content = getCurrentUrl();
			console.log("[Act] 触发复制事件~")
			return content || '';
		},
	});
	
	await getActivityConfig('a20240422mvpfd', {
		iChartId: "100000476",
		iSubChartId: "100000476",
		instanceid: 3000644,
	}, (data) => {
		console.log("拉取配置成功~==>", data);
		const {now, iActivityEndTime} = data;
		if (now >= iActivityEndTime) {
			// 活动结束
			updatePageEnd();
		} else {
			initPage();
		}
	}, (error) => {
		console.error("拉取配置失败~", error)
		initPage();
	})
	
	
	if (pandoraData.code) {
		await miloEmit(
			"3001278_2tEPC5", "8U5iCY", {
				iChartId: "100000663",
				iSubChartId: "100000663",
				instanceid: 3001278,
				code: pandoraData.code
			},
			(successData: MiloResponseType) => {
				console.log("successData", successData);
				const {iRet, jData} = successData;
				if (Number(iRet) !== 0) {
					console.error("请求失败~")
					return;
				}
				const {data: resultData} = jData;
				
				const {errcode} = resultData;
				if (errcode !== 1) {
					console.log("code 有误~")
					return;
				}
				
				if (!resultData.data) {
					return;
				}
				
				const {data: {kda, rewardList, itemList, score, skin, heroid}} = resultData;
				
				if (kda) {
					for (const kdaKey in kda) {
						MVP_DATA[kdaKey] = kda[kdaKey];
					}
					MVP_DATA.score = Number(score) || 0;
					// updateMvpData();
					app.mvpData = MVP_DATA;
				}
				let backgroundImageUrl = backgroundHeroTemplateImageUrl.replace('{heroId}',heroid.toString());
				if(skin != 0) {
					let showSkin = heroid.toString() + prefixNumber(skin);
					backgroundImageUrl = backgroundTemplateImageUrl.replace("{skinId}", showSkin);
				}
				
				// if(showSkin > 10000){
				// todo 是个正式的皮肤ID时
				const headDom = document.querySelector(".header") as HTMLElement;
				headDom.style.backgroundImage = `url(${backgroundImageUrl})`;
				// }
				
				if (rewardList) {
					for (const reward of rewardList) {
						// todo 设置默认展示的道具名称
						
						
						// 获取到后台传输的道具名称
						// let defaultRewardName: string;
						// try {
						// 	defaultRewardName = decodeURIComponent(reward.itemList[0].sItemName);
						// } catch (e) {
						// 	defaultRewardName = reward.itemList[0].sItemName;
						// }
						if(reward.icon) {
							if(!/^http(s)?:\/\/.+/.test(reward.icon)) {
								reward.icon = "https://" + reward.icon;
							}
						}else {
							reward.icon = defaultAvatarImage;
						}
						let temp: RewardListType = {
							headUrl: reward.icon,
							name: reward.name || defaultAvatarName,
							// time:new Date().getTime(),
							// 根据道具名称获取展示的多语言key
							rewardName: rewardNameLangKey[reward.itemList[0].iPackageId],
						};
						rewardListData.push(temp)
					}
					app.rewardList = rewardListData
				}
				
				// if (itemList) {
				// 	for (const item of itemList) {
				// 		let temp: ItemListType = {
				// 			itemName: item.itemName
				// 		}
				// 		itemListData.push(temp)
				// 	}
				// 	app.itemList = itemListData;
				// }
				
			},
			(failData) => {
				console.error("failData", failData);
			}
		)
	}
})();
